<script setup lang="ts">
import { APIFilters } from '~/utils/APIFilters'
import type { ProductCategory } from '~/types/api'

const { getResourceUrl } = useResources()

const categoryLinks = computed(() => {
  return Array.from(categories.value, (category: ProductCategory) => {
    return localePath({
      name: 'product-lines-category-slug',
      params: { slug: category.urlSlug },
    })
  })
})

// TODO get all pages
const { data: categoriesData, status } = await useLazyAsyncData(() =>
  createProductsRepository().getAllCategories({
    sort: APIFilters.makeSort({ weight: 'ASC', nid: 'ASC' }),
  })
)

const categories = computed(() => categoriesData.value?.items ?? [])

const localePath = useLocalePath()
</script>

<template>
  <div v-if="status == 'pending'">
    <UiSkeletonProductCategoryPicker />
  </div>
  <div
    v-else
    class="w-full border-b-4 border-white bg-neutral-100 px-10 lg:px-24"
  >
    <div class="center flex flex-col flex-wrap justify-between sm:flex-row">
      <NuxtLink
        v-for="(category, index) in categories"
        :key="category.nid"
        :to="categoryLinks[index]"
        class="font-bold no-underline transition duration-300"
      >
        <div class="group flex justify-start py-3 py-5 sm:justify-center">
          <div class="flex flex-row sm:flex-col">
            <img
              height="50"
              width="50"
              class="contrast-50 invert filter transition-all group-hover:invert-0"
              :class="{
                '!invert-0': $route.path === categoryLinks[index],
              }"
              loading="lazy"
              :src="getResourceUrl(category.image?.url)"
            />
            <p
              class="pl-6 pt-6 text-lg font-bold text-neutral-400 no-underline transition-all duration-300 group-hover:text-black sm:pl-0 sm:pt-2"
              :class="{
                '!text-black': $route.path === categoryLinks[index],
              }"
            >
              {{ category.title }}
            </p>
          </div>
        </div>
      </NuxtLink>
    </div>
  </div>
</template>
